import React from "react";
import { curry } from "ramda";
import strings from "localisation/strings";
import useMutation from "common/hooks/useMutation";
import DeleteButton from "components/buttons/DeleteButton";
import useNotification from "hooks/useNotification";
import { deleteInactiveBusinessRepresentative } from "api/businessRepresentatives";

interface Props {
  userId: string;
}

const InactiveBusinessRepresentativeDeleteButton = ({ userId }: Props) => {
  const deleteInactiveBusinessRepresentativeRequest = curry(
    deleteInactiveBusinessRepresentative,
  );
  const { makeRequest } = useMutation(
    deleteInactiveBusinessRepresentativeRequest,
  );
  const { addErrorNotification, addSuccessNotification } = useNotification(); // Display confirmation message

  const handleClick = async () => {
    const response = (await makeRequest(userId)) || {};

    if (response.error) {
      addErrorNotification(
        strings("adminPublicUsersPage.errors.generic"),
      ).then();
    } else {
      addSuccessNotification(
        strings(
          "adminPublicUsersPage.alert.inactiveBusinessRepresentativeDeleted",
        ),
      ).then();
      location.reload();
    }
  };

  return <DeleteButton onClick={handleClick} id={userId} />;
};

export default InactiveBusinessRepresentativeDeleteButton;
